import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {Body} from "@khanacademy/wonder-blocks-typography";

export default function TableRowNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, children} = props;

    return (
        <Body {...attributes} style={styles.tr} tag="tr">
            {children}
        </Body>
    );
}

const styles = StyleSheet.create({
    tr: {
        display: "table-row",
    },
});
